/**
 * Prompt Version History
 * Shows version list with option to view content and rollback.
 */

interface VersionItem {
  id: string;
  version: number;
  content: string;
  changeNote: string | null;
  createdAt: string;
  isCurrent: boolean;
}

interface PromptVersionHistoryProps {
  versions: VersionItem[];
  onRollback: (version: number) => void;
  onSelect: (version: VersionItem) => void;
  isLoading: boolean;
}

export default function PromptVersionHistory({
  versions,
  onRollback,
  onSelect,
  isLoading,
}: PromptVersionHistoryProps) {
  if (isLoading) {
    return (
      <div className="border-2 border-black dark:border-gray-700 p-4 text-center">
        <div className="w-6 h-6 border-2 border-gray-300 border-t-black dark:border-t-white rounded-full animate-spin mx-auto" />
      </div>
    );
  }

  if (versions.length === 0) {
    return (
      <div className="border-2 border-black dark:border-gray-700 p-4 text-center text-sm text-gray-500 dark:text-gray-400">
        Geen versies gevonden. Er zijn nog geen overrides aangemaakt.
      </div>
    );
  }

  return (
    <div className="border-2 border-black dark:border-gray-700 divide-y-2 divide-black dark:divide-gray-700">
      {versions.map((v) => (
        <div
          key={v.id}
          className="p-3 flex items-center justify-between hover:bg-gray-50 dark:hover:bg-gray-800/50 transition-colors cursor-pointer"
          onClick={() => onSelect(v)}
        >
          <div>
            <div className="flex items-center gap-2">
              <span className="font-mono text-sm font-bold text-black dark:text-white">
                v{v.version}
              </span>
              {v.isCurrent && (
                <span className="px-1.5 py-0.5 text-[10px] font-bold border-2 border-green-600 text-green-700 dark:text-green-400 bg-green-50 dark:bg-green-900/20">
                  ACTIEF
                </span>
              )}
            </div>
            {v.changeNote && (
              <p className="text-xs text-gray-500 dark:text-gray-400 mt-0.5">
                {v.changeNote}
              </p>
            )}
            <p className="text-[10px] text-gray-400 dark:text-gray-500 mt-0.5">
              {new Date(v.createdAt).toLocaleString('nl-NL')}
            </p>
          </div>
          {!v.isCurrent && (
            <button
              onClick={(e) => {
                e.stopPropagation();
                onRollback(v.version);
              }}
              className="px-2 py-1 text-xs font-bold border-2 border-black dark:border-gray-600 hover:bg-black hover:text-white dark:hover:bg-white dark:hover:text-black transition-colors"
            >
              Rollback
            </button>
          )}
        </div>
      ))}
    </div>
  );
}
